import { PropertySearchResult } from '@propertypal/shared/src/types/propertySearch';
import getOpenViewingsContent from '@propertypal/shared/src/utils/search/getOpenViewingsContent';
import Button from '@propertypal/web-ui/src/buttons/Button';
import CalendarIcon from '@propertypal/web-ui/src/calendar/CalendarIcon';
import { Text } from '@propertypal/web-ui/src/typography';
import Link from 'next/link';
import React from 'react';
import { Container, ButtonContainer } from './OpenViewingBox.style';

interface OpenViewingBoxProps {
  searchResult?: PropertySearchResult;
}

const OpenViewingBox: React.FC<OpenViewingBoxProps> = (props) => {
  const content = getOpenViewingsContent(props.searchResult);

  if (!content || props.searchResult?.results?.length === 0) {
    return null;
  }

  return (
    <Container data-testid="open-viewing-box">
      <CalendarIcon containerStyle={{ marginRight: 15 }} mode="black" date={content.date} />

      <Text data-testid="open-viewings-title">{content.text}</Text>

      <ButtonContainer>
        {content.links.map((link, index) => (
          <Link href={link} prefetch={false} key={link} data-testid="go-to-open-viewings">
            <Button type="button">{content?.linksText[index]}</Button>
          </Link>
        ))}
      </ButtonContainer>
    </Container>
  );
};

export default OpenViewingBox;
